/** Reference phone width (iPhone 14 Pro Max) — mobile UI is authored at this width. */
export const MOBILE_REF_WIDTH_PX = 430

/** Desktop layout starts at lg (1024px). Below this uses the mobile reference frame. */
export const DESKTOP_MIN_WIDTH_PX = 1024

/** Horizontal padding on ProcessSection stage (`max-lg:px-5` × 2). */
export const MOBILE_SECTION_PADDING_PX = 40

/** Scale mobile UI to fill the available content width (up or down from the 430px reference). */
export function mobileRefScale(
  viewportWidth: number,
  horizontalPadding = 0,
): number {
  if (viewportWidth >= DESKTOP_MIN_WIDTH_PX) return 1
  const available = Math.max(0, viewportWidth - horizontalPadding)
  return available / MOBILE_REF_WIDTH_PX
}
